export default "__VITE_ASSET__DvpsFQJs__"